import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SIGNUP } from '../../../workspace/shared/constants';
import { Header, Footer } from '../../shared/components';
import { Feature, Testimonial } from './components';
import { FEATURES, TESTIMONIALS } from './constants';

import WebsitePreview from './assets/website-preview.png';

import sharedStyles from '../../shared/styles/_sharedStyles.module.scss';
import componentStyles from './Home.module.scss';

const Home = () => {
  const featureList = FEATURES.map((feature) => (
    <Feature
      description={feature.description}
      icon={feature.icon}
      key={feature.title}
      title={feature.title}
    />
  ));

  const testimonialList = TESTIMONIALS.map((testimonial) => (
    <Testimonial
      content={testimonial.content}
      customer={testimonial.customer}
      key={testimonial.customer}
      location={testimonial.location}
    />
  ));

  return (
    <>
      <Header />

      <div className={componentStyles.container}>
        <div className={componentStyles.container__content}>
          <div className="row">
            <div className="col-md-6">
              <div className={componentStyles.welcome}>
                <h1 className={componentStyles.welcome__title}>
                  Funeral homes, <br />
                  <span className={componentStyles.welcome__subtitle}>
                    brought online.
                  </span>
                </h1>

                <p className={componentStyles.welcome__paragraph}>
                  All the tools you need to establish a digital presence for your
                  business. <br />
                  Start your free website trial today, no credit card required.
                </p>

                <a href={`${gon.workspace_url}${SIGNUP}`} className="btn">
                  Create Website
                  <FontAwesomeIcon icon="arrow-right" className="btn__icon" />
                </a>
              </div>
            </div>

            <div className="col-md-6 d-none d-sm-block">
              <div className={componentStyles.images}>
                <img
                  src="https://images.unsplash.com/photo-1591055749071-927e6ddffc82?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                  alt="Funeral home."
                  className={`${componentStyles.img} ${componentStyles['img--primary']}`}
                />

                <img
                  src="https://images.unsplash.com/photo-1515162305285-0293e4767cc2?q=80&w=1771&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                  alt="Funeral home."
                  className={`${componentStyles.img} ${componentStyles['img--secondary']}`}
                />

                <img
                  src="https://images.unsplash.com/photo-1489659523746-dd600cc1a245?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                  alt="Funeral home."
                  className={`${componentStyles.img} ${componentStyles['img--tertiary']}`}
                />
              </div>
            </div>
          </div>

          <div className={`row ${componentStyles['why-us']}`}>
            <div className="col-md-8">
              <h3 className={componentStyles['why-us__title']}>Why funeralApp?</h3>

              <h2 className={componentStyles['why-us__subtitle']}>
                More than a website.
              </h2>

              <p className={componentStyles['why-us__paragraph']}>
                funeralApp is the fastest and easiest way to have a direct sales channel
                for your funeral home. Build your website in minutes and quickly enable
                all the integrations you need.
              </p>
            </div>
          </div>

          <img
            src={WebsitePreview}
            alt="funeralApp preview."
            className={componentStyles['website-img']}
          />
        </div>

        <div className={componentStyles.background}>
          <div className={componentStyles.angle}>
            <svg
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              className={componentStyles.angle__top}
            >
              <polygon points="0,100 100,0 100,100" />
            </svg>
          </div>

          <div className={componentStyles['more-details']}>
            <div className={sharedStyles['content--lg']}>
              <div className={`row ${componentStyles.features}`}>{featureList}</div>

              <h2 className={componentStyles['testimonials-title']}>Customer stories.</h2>

              <div className="row">{testimonialList}</div>
            </div>
          </div>

          <div className={componentStyles.angle}>
            <svg
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              className={componentStyles.angle__btm}
            >
              <polygon points="100,0 0,100 0,0" />
            </svg>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Home;
